"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Monitoring = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var notificationsIsActive = function notificationsIsActive(recipients) {
  return recipients.some(function (recipient) {
    return recipient.assignedAlarms || recipient.etaAlarms || recipient.delayedStartEndAlarms || recipient.startStopAlarms;
  });
};

var Monitoring = function Monitoring(_ref) {
  var _wayPoints$, _wayPoints$2;

  var tour = _ref.tour,
      user = _ref.user;
  var intl = (0, _nicbaseTranslation.useIntl)();
  var isEtaMonitoringEnabled = tour.etaProvider !== null;
  var areAlarmsEnabled = tour.alarms && tour.alarms.length > 0;
  var isDelayedAlarmsEnabled = tour.delayedStartLimitAlarm !== null || tour.delayedEndLimitAlarm !== null;
  var isStartStopAlarmsEnabled = tour.startStopAlarmsEnabled === true;
  var _tour$emailRecipients = tour.emailRecipients,
      emailRecipients = _tour$emailRecipients === void 0 ? [] : _tour$emailRecipients,
      _tour$smsRecipients = tour.smsRecipients,
      smsRecipients = _tour$smsRecipients === void 0 ? [] : _tour$smsRecipients,
      _tour$wayPoints = tour.wayPoints,
      wayPoints = _tour$wayPoints === void 0 ? [] : _tour$wayPoints;
  var selectIndividualEmailNotifications = notificationsIsActive(emailRecipients);
  var selectIndividualSmsNotifications = notificationsIsActive(smsRecipients);
  var earlyTolerance = wayPoints[0] && ((_wayPoints$ = wayPoints[0]) === null || _wayPoints$ === void 0 ? void 0 : _wayPoints$.earlyTolerance);
  var lateTolerance = wayPoints[0] && ((_wayPoints$2 = wayPoints[0]) === null || _wayPoints$2 === void 0 ? void 0 : _wayPoints$2.lateTolerance);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col pt-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    className: "cursor-default",
    checked: isStartStopAlarmsEnabled,
    disabled: true,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.monitor.startStopAlarmsEnabled",
      tagName: "span"
    }),
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.monitor.startStopAlarmsEnabled",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col mb-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    className: "cursor-default",
    checked: isDelayedAlarmsEnabled,
    disabled: true,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.monitor.delayedStartEndAlarms",
      tagName: "span"
    }),
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.monitor.delayedStartEndAlarms",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-6 mx-2"
  }, tour.delayedStartLimitAlarm ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.monitor.delayedStartLimitAlarm"
  }), ' ', /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.delayedStartLimitAlarm,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })) : null, tour.delayedEndLimitAlarm ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.monitor.delayedEndLimitAlarm"
  }), ' ', /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.delayedEndLimitAlarm,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col mb-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    className: "cursor-default",
    checked: isEtaMonitoringEnabled,
    disabled: true,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.monitor.ETA",
      tagName: "span"
    }),
    hideLabel: true
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.monitor.ETA",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-6 mx-2"
  }, earlyTolerance ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    values: {
      x: Math.round(earlyTolerance / 60)
    },
    id: "widgets.tourBoard.rail.details.monitor.earlyTolerance"
  })) : null, lateTolerance ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    values: {
      x: Math.round(lateTolerance / 60)
    },
    id: "widgets.tourBoard.rail.details.monitor.lateTolerance"
  })) : null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, emailRecipients.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, intl.formatMessage({
    id: 'widgets.tourBoard.rail.details.monitor.emailNotifications'
  })), selectIndividualEmailNotifications && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-1 flex"
  }, areAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.alarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Alarms, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isEtaMonitoringEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.eta'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ETA, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isDelayedAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.delayedStartEndAlarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DelayNotificationAlarm, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isStartStopAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.startStopAlarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.StartStopAlarmsEnabled, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  }))), emailRecipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex p-0 mt-2 align-center"
    }, selectIndividualEmailNotifications && /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex"
    }, areAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.assignedAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.alarms'
      }),
      hideLabel: true
    }), isEtaMonitoringEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.etaAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.eta'
      }),
      hideLabel: true
    }), isDelayedAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.delayedStartEndAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.delayedStartEndAlarms'
      }),
      hideLabel: true
    }), isStartStopAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.startStopAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.startStopAlarms'
      }),
      hideLabel: true
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "recipient"
    }, recipient.recipient));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, smsRecipients.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, intl.formatMessage({
    id: 'widgets.tourBoard.rail.details.monitor.smsNotifications'
  })), selectIndividualSmsNotifications && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-1 flex"
  }, areAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.alarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Alarms, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isEtaMonitoringEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.eta'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ETA, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isDelayedAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.delayedStartEndAlarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DelayNotificationAlarm, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  })), isStartStopAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.startStopAlarms'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.StartStopAlarmsEnabled, {
    className: "fill-current text-primary h-5 w-5 my-0 ml-1 mr-2"
  }))), smsRecipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex p-0 mt-2 align-center"
    }, selectIndividualSmsNotifications && /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex"
    }, areAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.assignedAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.alarms'
      }),
      hideLabel: true
    }), isEtaMonitoringEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.etaAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.eta'
      }),
      hideLabel: true
    }), isDelayedAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.delayedStartEndAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.delayedStartEndAlarms'
      }),
      hideLabel: true
    }), isStartStopAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      className: "flex justify-center w-8 cursor-default my-0 ml-0",
      checked: recipient.startStopAlarms,
      disabled: true,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.startStopAlarms'
      }),
      hideLabel: true
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-64"
    }, recipient.recipient));
  }))));
};

exports.Monitoring = Monitoring;
Monitoring.propTypes = {
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }).isRequired,
  tour: _propTypes["default"].shape({
    startStopAlarmsEnabled: _propTypes["default"].bool,
    delayedStartLimitAlarm: _propTypes["default"].string,
    delayedEndLimitAlarm: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      type: _propTypes["default"].string
    })),
    smsRecipients: _propTypes["default"].shape(),
    emailRecipients: _propTypes["default"].shape(),
    etaProvider: _propTypes["default"].string
  }).isRequired
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Monitoring);

exports["default"] = _default;